export function formatUsdCents(cents: number | null | undefined): string {
  if (cents === null || cents === undefined) return '—'
  const amount = `$${(Math.abs(cents) / 100).toFixed(2)}`
  return cents < 0 ? `-${amount}` : amount
}

export function dollarsToCents(dollars: number | null | undefined): number {
  if (dollars === null || dollars === undefined) return 0
  return Math.round(dollars * 100)
}

export function centsToDollars(
  cents: number | null | undefined,
): number | null {
  if (cents === null || cents === undefined) return null
  return cents / 100
}
